module.exports = __webpack_public_path__ + "img/46ed44c.jpg";